export function initPageDOM(): void {
    if (document.body.dataset.type === 'landingPage') {
        document.body.classList.add('pt-16');
    }

    if (document.body.dataset.type === 'product') {
        const accordions = document.querySelectorAll<HTMLElement>('.accordionGroup');
        accordions.forEach((item, index) => {
            if (index === 0) item.classList.add('pt-10');
            if (index === accordions.length - 1) {
                item.classList.add('pb-10', 'lg:pb-20');
            }
            const subItems = item.querySelector('#container-' + item.id)?.querySelectorAll('section');
            if (subItems && subItems.length > 1) {
                subItems.forEach((subItem, i) => {
                    subItem.querySelector('.container')?.classList.add('!px-0');
                    if (i === 0) subItem.classList.add('!pb-0', '!pt-10');
                });
            }
        });
    }
}
